import React from 'react';

import { List, FilterForm, Datagrid } from 'components/list';
import { TextInput } from 'components/input';
import { TextField } from 'components/field';
import { EditButton } from 'components/button';

import {
    emailByShopFrontendPath,
    shopReportResendFrontendPath,
    shopPushDeviceListFrontendPath,
} from './urls';


export const ShopListFilter = (props) => (
  <FilterForm name="shop_list_filter" {...props}>
    <TextInput isRequired={true} label="Mobile" source="mobile_number"/>
  </FilterForm>
);

export const ShopList = (props) => (
  <List {...props} filters={<ShopListFilter />}>
    <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
      <TextField source="shop_id" label="Shop ID"/>
      <TextField source="shop_name" label="Shop Name"/>
      <TextField source="owner_mobile" label="Owner Mobile"/>
      <TextField source="owner_name" label="Owner Name"/>
      <EditButton linkTo={shopReportResendFrontendPath} label="Report"/>
      <EditButton linkTo={emailByShopFrontendPath} label="Email"/>
      <EditButton linkTo={shopPushDeviceListFrontendPath} label="GET LOG" columnName="CLIENT LOG"/>
    </Datagrid>
  </List>
);


// WEBPACK FOOTER //
// ./src/routes/shop/ShopList.js